export default __webpack_public_path__ + "static/media/GothamSSm-Medium.25f1e3a7.ttf";